module.exports = __webpack_public_path__ + "img/code.2bb839b1.png";